import type {CommonDescriptionAttribute} from '../types/CommonDescriptionAttribute';
import type {CommonFinancingPriceAttribute} from '../types/CommonFinancingPriceAttribute';
import type {CommonMileageAttribute} from '../types/CommonMileageAttribute';
import type {CommonPriceAttribute} from '../types/CommonPriceAttribute';
import type {CommonTitleExtensionAttribute} from '../types/CommonTitleExtensionAttribute';
import type {CommonVinAttribute} from '../types/CommonVinAttribute';
import type {TipCarsPriceNoteAttribute} from '../types/TipCarsPriceNoteAttribute';

export type VehicleTipCarsPlatformAdvertisingAttribute =
  | CommonTitleExtensionAttribute
  | CommonVinAttribute
  | CommonMileageAttribute
  | CommonPriceAttribute
  | CommonFinancingPriceAttribute
  | TipCarsPriceNoteAttribute
  | CommonDescriptionAttribute;
